<template>
    <el-container>

        <el-main>
            <el-dialog :title="categoryTitle" :visible.sync="showCategory" width="35%" :close-on-click-modal=false :before-close="handleDialogClose">
                <el-form ref="formData" :model="formData" label-width="130px" :rules="rules" class="demo-ruleForm">
                    <el-form-item label="上级分类：" prop="parentName">
                        <el-input v-model="formData.parentName"  placeholder="上级分类" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="分类名称：" prop="ccName">
                        <el-input v-model="formData.ccName"  placeholder="分类名称"></el-input>
                    </el-form-item>
                    <el-form-item label="分类英文名称：" prop="ccEnglishName" v-if="loginOrgCode == 'blcuonline'">
                        <el-input v-model="formData.ccEnglishName"  placeholder="分类英文名称"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose">取 消</el-button>
                    <el-button type="primary" @click="saveCategory('formData')">确 定</el-button>
                </div>
            </el-dialog>
            <el-select v-if="orgType == 1" placeholder="" size="small" placeholder="机构" v-model="orgCode" @change="changeOrg" style="margin-right: 10px;">
                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
            </el-select>
            <el-button type="success" align="right" icon="el-icon-circle-plus-outline" size="small" round @click="addCategory" class="but-cls">添加一级分类</el-button>
            <el-table
                    :data="treeData"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="ccId"
                    border
                    ref="tableData"
                    :loading = "loading"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column
                        prop="ccName"
                        label="分类名称"
                >
                </el-table-column>
                <el-table-column prop="isView" label="首页显示" width="100">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.isView"
                            v-if="scope.row.level != 3"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :disabled="disableStatus(scope.$index,scope.row)"
                            :active-value="1"
                            :inactive-value="0"
                            @change="updateIsView(scope.$index, scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="250"
                >
                    <template slot-scope="scope">
                        <template v-if="scope.row.level < maxLevel">
                            <el-button @click="addCategory(scope.$index, scope.row)"  size="small" type="text">添加</el-button>
                        </template>
                        <el-button @click="updateCategory(scope.$index, scope.row)" type="text"  size="small">修改</el-button>
                        <el-button @click="deleteCategory(scope.$index, scope.row)" type="text"  size="small">删除</el-button>
                        <el-button @click="upCategory(scope.$index, scope.row)" type="text"  size="small">上移</el-button>
                        <el-button @click="downCategory(scope.$index, scope.row)" type="text"  size="small">下移</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>

</template>

<script>
    import https from '@/https.js'
    const formData = {
        ccId: "",
        ccName:"",
        ccEnglishName: '',
        loginOrgCode: '',
        parentId:"0",
        ccSort: "",
        parentName: "",
        classLayer: "",
        level: 1,
        orgCode: '',
    };
    export default {
        data() {
            const data = [];
            return {
                org: [],
                orgCode: '',
                orgType: '',
                maxLevel: 2,
                showTree: true,
                treeData: [],
                top: false,
                showCategory:false,
                loading: false,
                categoryTitle: "添加分类",
                formData: JSON.parse(JSON.stringify(formData)),
                defaultProps: {
                    children: 'children',
                    label: 'ccName'
                },
                rules: {
                    ccName: [
                        { required: true, message: '请填写分类名称', trigger: 'blur' },
                        {  max: 20, message: '长度不得超过 20 个字符', trigger: 'blur' }
                    ],
                  ccEnglishName: [
                    { required: true, message: '请填写分类名称', trigger: 'blur' },
                    {  max: 200, message: '长度不得超过 200 个字符', trigger: 'blur' }
                  ]
                },
            }
        },

        methods: {
          changeOrg(val,row) {
            for(let org of this.org) {
              if(val == org.orgCode) {
                if(org.type == 1) {
                  this.maxLevel = 3;
                } else {
                  this.maxLevel = 2;
                }
              }
            }
            if(this.loginOrgCode == 'blcuonline') {
              this.maxLevel = 3;
            }
            this.search(val);
          },
          selectOrg() {
            https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.org = data.data.data;
                if(this.org.length > 0) {
                  this.orgCode = this.org[0].orgCode;
                }
                this.search(this.orgCode);
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          },
            handleDialogClose() {
                this.showCategory = false;
                this.formData.ccId = "";
                this.categoryTitle = "添加分类"
                this.formData = JSON.parse(JSON.stringify(formData));
                this.$refs.formData.clearValidate();
            },
            search(val) {
                this.loading = true;
                if(val == '' || val == undefined) {
                  val = this.orgCode;
                }
                let params = {
                  orgCode: val,
                };
                https.fetchPost('/courseCategoryInfo/selectListRecursion',params, "json" ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.loading = false;
                        let treeData = [];
                        if(data.data.data != undefined) {
                          treeData = data.data.data;
                        }
                        this.treeData = treeData
                    } else {
                        this.loading = false;
                        this.$message({
                            type: 'info',
                            message: '加载失败'+msg
                        });
                    }

                }).catch(err=>{
                    this.$message.error('网络错误');
                    this.loading = false;
                    }
                )
            },
            addCategory(index, row) {
                this.showCategory = true;
                let parentName = "";
                let classLayer = "1";
                let parentId = "0";
                let level = 1;
                if(row) {
                    let _row = JSON.parse(JSON.stringify(row));
                    parentId = _row.ccId;
                    parentName = _row.ccName;
                    classLayer = _row.classLayer+1;
                    level = _row.level+1;
                }
                this.formData.parentId = parentId;
                this.formData.parentName = parentName;
                this.formData.classLayer = classLayer;
                this.formData.level = level;
            },
            updateCategory(index, row) {
                this.categoryTitle = "修改分类";
                this.showCategory = true;
                this.formData = JSON.parse(JSON.stringify(row));
            },
            deleteCategory(index, row) {
              this.$confirm('此操作将删除该分类信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let params = {
                  ccId: row.ccId
                };
                https.fetchPost('/courseCategoryInfo/deleteByCcId',params , 'json').then((data) => {
                  let code = data.data.code;
                  let msg = data.data.msg;
                  if(code == '200') {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    this.search();
                  } else {
                    this.$message({
                      type: 'info',
                      message: '删除失败:'+msg
                    });
                  }
                }).catch(err=>{
                      this.$message.error('网络异常！');
                    }
                );

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            },
            saveCategory(formName) {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error('请正确填写信息！');
                        return false;
                    }else {
                        let params = this.formData;
                        let url = "/courseCategoryInfo/insertByParentId";
                        this.formData.orgCode = this.orgCode;
                        if(this.formData.ccId != "") {
                            url = "/courseCategoryInfo/updateNameByCcId";
                        }
                        https.fetchPost(url,params ,"json").then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if(code == '200') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.showCategory = false;
                                this.formData = JSON.parse(JSON.stringify(formData));
                                this.search();
                            } else {
                                this.$message.error('操作失败:'+msg);
                            }

                        }).catch(err=>{
                                console.log(err);
                                this.$message.error('网络错误');
                            }
                        )
                    }
                });
            },
            upCategory(index, row) {
                let params = row;
                https.fetchPost('/courseCategoryInfo/updateUpSort',params, "json" ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.search();
                    } else {
                        this.$message({
                            type: 'info',
                            message: '操作失败:'+msg
                        });
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                        this.loading = false;
                    }
                )
            },
            downCategory(index, row) {
                let params = row;
                https.fetchPost('/courseCategoryInfo/updateDownSort',params, "json" ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.search();
                    } else {
                        this.$message({
                            type: 'info',
                            message: '操作失败:'+msg
                        });
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                        this.loading = false;
                    }
                )
            },
            updateIsView(index, row) {
                console.log(row);
                if(row.level==1 && row.isView==0){
                    if(row.children && row.children.length>0){
                        row.children.forEach(item=>{item.isView=0;});
                    }
                }                
                let params = {
                   ccId:row.ccId,
                   isView:row.isView
                };
                https.fetchPost('/courseCategoryInfo/updateIsView',params, "json" ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.search();
                        
                    } else {
                        this.$message({
                            type: 'info',
                            message: '操作失败:'+msg
                        });
                    }
                }).catch(err=>{
                        this.$message.error('网络错误');
                        this.loading = false;
                    }
                )
            },
            disableStatus:function(index, row){
                let level = row.level;
                if(level==1){
                    return false;
                }
                else if(level==2){
                    let parentId = row.parentId;
                    let parentItem = this.treeData.find(function(item){
                        return item.ccId==parentId;
                    });
                    console.log(parentItem);
                    if(parentItem.isView==0){
                        return true;
                    }
                }
                return false;
            }  
        },
        computed:{
            
        },
        created: function () {
            this.orgType = this.$store.state.orgType;
            this.loginOrgCode = this.$store.state.orgCode;
            if(this.orgType == 1) {
              this.maxLevel = 3;
            }
              if(this.loginOrgCode == 'blcuonline') {
                this.maxLevel = 3;
              }
            this.selectOrg();
            
        }
    };
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
</style>